// extracted by mini-css-extract-plugin
export var newsEntriesPresentationCard = "singleNewsEntryItem-module--newsEntriesPresentationCard--af332";
export var newsEntriesPresentationList = "singleNewsEntryItem-module--newsEntriesPresentationList--f8bf4";
export var newsEntryCardLabel = "singleNewsEntryItem-module--newsEntryCardLabel--53ed1";
export var newsEntryCopyWrapper = "singleNewsEntryItem-module--newsEntryCopyWrapper--48685";
export var newsEntryDate = "singleNewsEntryItem-module--newsEntryDate--fb166";
export var newsEntryDescription = "singleNewsEntryItem-module--newsEntryDescription--fcf29";
export var newsEntryItem = "singleNewsEntryItem-module--newsEntryItem--d6711";
export var newsEntryLogoWrapper = "singleNewsEntryItem-module--newsEntryLogoWrapper--1c589";
export var newsEntryReadMore = "singleNewsEntryItem-module--newsEntryReadMore--6d067";
export var newsEntryTitle = "singleNewsEntryItem-module--newsEntryTitle--b692a";